:host {
  display: block;
}

.spw-field-message {
  display: block;
  margin-top: 8px;
  display: flex;
  gap: 4px;

  &--error {
    color: var(--spw-color-states-error-error-300);
  }

  &--hint {
    color: var(--spw-colors-support-grey-grey-600);
  }

  &--success {
    color: var(--spw-color-states-success-success-500);
  }

  &__icon {
    position: relative;
    top: 1px;
  }

  &__text {
    flex: 1;
    font-size: 14px;
    line-height: 1.5;
  }
}
